import React, { useEffect, useState } from 'react';
import { DateTime } from 'luxon';
import styled from '@emotion/styled';

const DateTimeWrapper = styled.p`
  ${({ theme }) => theme.mixins.flexRowCenter};
`;
const NewYorkTime = () => {
  const [nyTime, setNyTime] = useState('');
  //   const [utcOffset, setUtcOffset] = useState('');

  useEffect(() => {
    // Immediately set the time and UTC offset on initial render
    const currentTime = DateTime.now().setZone('America/New_York');
    setNyTime(currentTime.toFormat('hh:mm:ss a'));

    // Get the UTC offset in hours and minutes (e.g., -05:00 for New York)
    // const offset = currentTime.offset; // UTC offset in minutes
    // const offsetHours = Math.floor(offset / 60);
    // setUtcOffset(
    //   `${offsetHours >= 0 ? '+' : '-'}${String(Math.abs(offsetHours)).padStart(1, '0')}`,
    // );

    const intervalId = setInterval(() => {
      const updatedTime = DateTime.now().setZone('America/New_York');
      setNyTime(updatedTime.toFormat('hh:mm:ss a'));

      // Update the UTC offset in real-time
      //   const updatedOffset = updatedTime.offset;
      //   const updatedOffsetHours = Math.floor(updatedOffset / 60);
      //   setUtcOffset(
      //     `${updatedOffsetHours >= 0 ? '+' : '-'}${String(Math.abs(updatedOffsetHours)).padStart(1, '0')}`,
      //   );
    }, 1000); // Update every second

    // Cleanup interval on unmount
    return () => clearInterval(intervalId);
  }, []); // Run once on mount

  return <DateTimeWrapper>{nyTime}</DateTimeWrapper>;
};

export default NewYorkTime;
